module.exports = __webpack_public_path__ + "img/icon-upload.1f2e0a98.svg";